/**
 * hintSelection.js
 *
 * DEAD SIGNAL — Chapter-6 hint objective selection (pure, node-testable).
 *
 * OWNER RULING 2026-06-12: the hint ladder NEVER fires during an active
 * interview. In the room the game answers in fiction (Hargrove dodges harder
 * without evidence; Craine asks anyway). Outside, Craine coaches. Priority:
 *   1. Repeated suppression, never adapted, at least one interview behind us
 *      -> relocated interference coaching (6.7).
 *   2. A proof-locked thread was pressed without its item, item still missing
 *      -> the four-step gather ladder for that thread (6.2_*). The donation
 *      thread is exempt by design (never proof-locked).
 *   3. Donation pressed and nothing harder pending -> sincerity read (6.6).
 *   4. No Helios evidence captured yet -> explore the building (6.1).
 *   5. Default -> pick a thread (6.3).
 *
 * Kept import-free so the golden runner (scripts/test-hint-ladder.js) loads it
 * under node without the store/audio dependency chain.
 */

const HELIOS_EVIDENCE = ['COURIER_MANIFEST', 'CHIP_DONATION_TIMING', 'ST_ERASMUS_ROUTING', 'CELESTE_PHOTO', 'NETWORK_PING'];

/**
 * @param {object} s plain snapshot:
 *   { interviewActive, suppressedCount, hasRoutedAround, reEngagementCount,
 *     pressedWithoutEvidence: string[], exploredTopics: string[], evidence: string[] }
 * @returns {string|null} objective id, or null (no coaching available)
 */
export function selectCh6Objective(s = {}) {
  if (s.interviewActive) return null;
  const evidence = s.evidence || [];
  const pressedWithout = s.pressedWithoutEvidence || [];
  const explored = s.exploredTopics || [];

  if ((s.suppressedCount || 0) >= 2 && !s.hasRoutedAround && (s.reEngagementCount || 0) >= 1) {
    return '6.7_interference_postexit';
  }
  if (pressedWithout.includes('courier_manifest') && !evidence.includes('COURIER_MANIFEST')) {
    return '6.2_evidence_courier';
  }
  if (pressedWithout.includes('clinical_trial_st_erasmus') && !evidence.includes('ST_ERASMUS_ROUTING')) {
    return '6.2_evidence_erasmus';
  }
  if (explored.includes('chip_donation')) {
    return '6.6_donation_sincerity';
  }
  const hasExaminedEvidence = evidence.some((e) => HELIOS_EVIDENCE.includes(e));
  if (!hasExaminedEvidence) return '6.1_explore_building';
  return '6.3_pick_a_thread';
}
